<div class="popup" *ngIf="isOpen">
  <div class="popup-content order-success-sec">
    <img [src]="successIcon" alt="Success Icon">
    <mat-icon class="close-popup" (click)="onClose()">close</mat-icon>

    <h3 *ngIf="isUpdate">Request Updated!</h3>
    <h3 *ngIf="!isUpdate">Request Created!</h3>

    <p class="order-label">
      <span class="order-id">
        Request ID {{ requestId }}
      </span>
    </p>

    <p class="date" *ngIf="requestCreatedAt">
      <span>
        {{ requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}
      </span>
    </p>

    <p class="thank-you">Let us deliver an awesome experience!</p>

    <button class="goto-order" (click)="onTrackRequest()">
      Track My Request
    </button>
  </div>
</div>